// @ts-strict-ignore
import { Component, OnInit } from "@angular/core";
import { ErrorCheck } from "src/app/shared/models/error-check.model";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";
import * as ProfileModel from "src/app/shared/models/profile.model";
import { DataService } from "src/app/shared/services/data.service";

@Component({
  selector: C.EWIZ_SEQUENCE_NUMBER_OPTIONS,
  templateUrl: "./sequence-number-options.component.html",
  standalone: false
})
export class EWizSequenceNumberOptionsComponent extends EWizDynamicBaseClassComponent implements OnInit, ErrorCheck {
  constructor(private dataService: DataService) {
    super();
  }

  ngOnInit() {
    this.errorCheck(this.profileValues, this.dataService);
  }

  errorCheck(values: ProfileModel.ProfileDto, dataService: DataService) {
    // Always reset error values to default state prior to executing check
    this.errorFound = false;
    this.errorMessage = "";

    // If SQN Delta is used, value must be present and within value range
    if (+values.networkAuthentication.sqnOptions.sqnDelta === 1) {
      if (dataService.isNullOrEmpty(values.networkAuthentication.sqnOptions.sqnDeltaValue)) {
        this.errorMessage = $localize`sqnDelta value must be entered`;
        this.errorFound = true;
        return true;
      } else if (!dataService.validHexValue(values.networkAuthentication.sqnOptions.sqnDeltaValue, 6, 6)) {
        this.errorMessage = $localize`sqnDelta value must be 6 HEX bytes in length`;
        this.errorFound = true;
        return true;
      } else if (!dataService.hexValueInRange(values.networkAuthentication.sqnOptions.sqnDeltaValue, 0x000000000000, 0x07ffffffffff)) {
        this.errorMessage = $localize`sqnDelta value must be between 000000000000 and 07FFFFFFFFFF`;
        this.errorFound = true;
        return true;
      }
    }

    // If SQN Age Limit is used, value must be present and within value range
    if (+values.networkAuthentication.sqnOptions.sqnAgeLimit === 1) {
      if (dataService.isNullOrEmpty(values.networkAuthentication.sqnOptions.sqnAgeLimitValue)) {
        this.errorMessage = $localize`sqnAgeLimit value must be entered`;
        this.errorFound = true;
        return true;
      } else if (!dataService.validHexValue(values.networkAuthentication.sqnOptions.sqnAgeLimitValue, 6, 6)) {
        this.errorMessage = $localize`sqnAgeLimit value must be 6 HEX bytes in length`;
        this.errorFound = true;
        return true;
      } else if (!dataService.hexValueInRange(values.networkAuthentication.sqnOptions.sqnAgeLimitValue, 0x000000000000, 0x07ffffffffff)) {
        this.errorMessage = $localize`sqnAgeLimit value must be between 000000000000 and 07FFFFFFFFFF`;
        this.errorFound = true;
        return true;
      }
    }

    return false;
  }
}
